'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryContentAdvisoryEditor = require('./components/PrimaryContentAdvisoryEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryContentAdvisoryEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/primary-content-advisory-editor/index.js
// module id = 1528
// module chunks = 1